
import { Card, CardContent } from "@/components/ui/card";
import { useI18n } from '../i18n/i18n';
import { useSEO } from '../hooks/useSEO';

const TermsPage = () => {
  const { t } = useI18n();
  
  // SEO Configuration
  const seoContent = useSEO('legal', 'terms');

  return (
    <div className="fade-in relative py-12 bg-[#F9FAFB]">
      {seoContent}
      <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-gradient-to-bl from-orange-100/30 to-transparent rounded-bl-full -z-10" />
      <div className="absolute bottom-0 left-0 w-1/4 h-1/4 bg-gradient-to-tr from-orange-100/30 to-transparent rounded-tr-full -z-10" />

      <div className="container mx-auto px-4 md:px-6">
        <Card className="max-w-4xl mx-auto">
          <CardContent className="p-6 md:p-8">
            <h1 className="text-3xl font-bold text-neutral-800 mb-6">
              {t('terms.title')}
            </h1>
            <p className="text-sm text-neutral-600 mb-8">
              {t('terms.lastUpdated')}: 04/05/2025
            </p>

            <div className="prose prose-neutral max-w-none">
              <p className="mb-6">{t('terms.welcome')}</p>
              <p className="mb-8 font-semibold">{t('terms.pleaseRead')}</p>

              <h2 className="text-xl font-semibold mt-8 mb-4">{t('terms.section1.title')}</h2>
              <p className="mb-4">{t('terms.section1.content')}</p>

              <h3 className="text-lg font-semibold mt-6 mb-3">{t('terms.section1.definitions')}</h3>
              <ul className="list-disc pl-6 mb-6">
                <li className="mb-2">{t('terms.section1.def1')}</li>
                <li className="mb-2">{t('terms.section1.def2')}</li>
                <li className="mb-2">{t('terms.section1.def3')}</li>
              </ul>

              <h2 className="text-xl font-semibold mt-8 mb-4">{t('terms.section2.title')}</h2>
              <p className="mb-4">{t('terms.section2.content')}</p>
              <div className="bg-orange-50 p-4 rounded-lg my-6">
                <h4 className="font-semibold mb-2">{t('terms.section2.disclaimer.title')}</h4>
                <p className="mb-2">{t('terms.section2.disclaimer.content1')}</p>
                <p className="mb-2">{t('terms.section2.disclaimer.content2')}</p>
                <p>{t('terms.section2.disclaimer.content3')}</p>
              </div>

              <h2 className="text-xl font-semibold mt-8 mb-4">{t('terms.section3.title')}</h2>
              <p className="mb-4">{t('terms.section3.eligibility')}</p>
              <h3 className="text-lg font-semibold mb-3">{t('terms.section3.conduct.title')}</h3>
              <ul className="list-disc pl-6 mb-6">
                <li className="mb-2">{t('terms.section3.conduct.items.0')}</li>
                <li className="mb-2">{t('terms.section3.conduct.items.1')}</li>
                <li className="mb-2">{t('terms.section3.conduct.items.2')}</li>
                <li className="mb-2">{t('terms.section3.conduct.items.3')}</li>
                <li className="mb-2">{t('terms.section3.conduct.items.4')}</li>
                <li className="mb-2">{t('terms.section3.conduct.items.5')}</li>
              </ul>
              <p className="mb-6">{t('terms.section3.security')}</p>

              <h2 className="text-xl font-semibold mt-8 mb-4">{t('terms.section4.title')}</h2>
              <p className="mb-4">{t('terms.section4.content')}</p>
              <p className="mb-4">{t('terms.section4.license')}</p>
              <p className="mb-6">{t('terms.section4.restrictions')}</p>

              <h2 className="text-xl font-semibold mt-8 mb-4">{t('terms.section5.title')}</h2>
              <p className="mb-4">{t('terms.section5.useAtOwnRisk')}</p>
              <p className="mb-4">{t('terms.section5.accuracy')}</p>
              <p className="mb-4">{t('terms.section5.investmentRisks')}</p>
              <p className="mb-4">{t('terms.section5.noRecommendations')}</p>
              <p className="mb-6">{t('terms.section5.tools')}</p>

              <h2 className="text-xl font-semibold mt-8 mb-4">{t('terms.section6.title')}</h2>
              <p className="mb-6">{t('terms.section6.content')}</p>

              <h2 className="text-xl font-semibold mt-8 mb-4">{t('terms.section7.title')}</h2>
              <p className="mb-6">{t('terms.section7.content')}</p>

              <h2 className="text-xl font-semibold mt-8 mb-4">{t('terms.section8.title')}</h2>
              <p className="mb-6">{t('terms.section8.content')}</p>

              <h2 className="text-xl font-semibold mt-8 mb-4">{t('terms.section9.title')}</h2>
              <p className="mb-6">{t('terms.section9.content')}</p>

              <h2 className="text-xl font-semibold mt-8 mb-4">{t('terms.section10.title')}</h2>
              <p className="mb-6">{t('terms.section10.content')}</p>

              <h2 className="text-xl font-semibold mt-8 mb-4">{t('terms.section11.title')}</h2>
              <p className="mb-6">{t('terms.section11.content')}</p>

              <h2 className="text-xl font-semibold mt-8 mb-4">{t('terms.section12.title')}</h2>
              <p className="mb-6">{t('terms.section12.content')}</p>

              <h2 className="text-xl font-semibold mt-8 mb-4">{t('terms.section13.title')}</h2>
              <p className="mb-6">{t('terms.section13.content')}</p>

              <h2 className="text-xl font-semibold mt-8 mb-4">{t('terms.contact.title')}</h2>
              <p>{t('terms.contact.content')}</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TermsPage;
